import createHistory from 'history/createBrowserHistory'
import * as React from 'react'
import { hydrate } from 'react-dom'
import { AppContainer } from 'react-hot-loader'

import { clientFinishedLoading } from '../../common/actions/common'
import configureStore from '../../common/store/configureStore'
import legacyAffiliates from '../../common/utils/legacyAffiliates'
import App from './app'

import '../../assets/stylesheets/compontents.css'
import '../../assets/stylesheets/core.css'
import '../../assets/stylesheets/search.css'
import '../../assets/stylesheets/style.css'

const history = createHistory()

// this only runs on initial hydrating
const initialState = (window as any).INITIAL_STATE
delete (window as any).INITIAL_STATE

const store = configureStore(initialState, history)

legacyAffiliates(window.location)

hydrate(
  <AppContainer>
    <App store={store} history={history} />
  </AppContainer>,
  document.querySelector('#react-view'),
  () => {
    store.dispatch(clientFinishedLoading())
  }
)

if (module.hot) {
  module.hot.accept('./app', () => {
    const NewApp = require('./app').default
    hydrate(
      <AppContainer>
        <NewApp store={store} history={history} />
      </AppContainer>,
      document.querySelector('#react-view')
    )
  })
}
